import { put, takeLatest } from 'redux-saga/effects';
import {
  getAllFailure,
  getAllRequest,
  getAllSuccess,
} from 'redux/slice/agency-onbording/DocumentColumn.slice';
import { agencyOnboarding } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* handleGetAllDocuments(action: any): any {
  try {
    const { params } = action.payload || {};
    const queryString = new URLSearchParams(params).toString();
    const response = yield HTTPClient.GetRequest(
      agencyOnboarding.GET_DOCUMENT_COLUMN_MASTER(queryString)
    );
    if (response.status === 200) {
      yield put(getAllSuccess(response.data));
    }
  } catch (error) {
    yield put(getAllFailure('Something went wrong!'));
  }
}

export function* watchGetAllDocuments() {
  yield takeLatest(getAllRequest.type, handleGetAllDocuments);
}
